export default function ContactSection() {
  return (
    <section id="contact" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-600 mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Contact
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-5"
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}
          >
            Get in Touch
          </h2>
          <p
            className="text-gray-500 text-lg max-w-xl mx-auto"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Have questions about our products or want to learn more about ADDON SH.P.K.? We'd love to hear from you.
          </p>
        </div>

        {/* Contact Card */}
        <div
          className="rounded-3xl overflow-hidden"
          style={{ background: '#0d1117' }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left: Image + overlay */}
            <div className="relative min-h-72 lg:min-h-0">
              <img
                src="https://public.readdy.ai/ai/img_res/85c2d01f3f0b1290fd46ff6fb4a95fad.jpg"
                alt="Tirane, Albania"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/60 lg:bg-gradient-to-r lg:from-transparent lg:to-[#0d1117]"></div>
              <div className="absolute bottom-8 left-8">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                  <i className="ri-map-pin-fill text-emerald-400 text-sm"></i>
                  <span className="text-white text-sm font-medium" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                    Tirane, Albania
                  </span>
                </div>
              </div>
            </div>

            {/* Right: Contact Info */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <h3
                className="text-2xl font-bold text-white mb-10"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                ADDON SH.P.K.
              </h3>

              {/* Address */}
              <div className="mb-8">
                <p
                  className="text-xs font-semibold tracking-widest uppercase text-emerald-400 mb-3"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Address
                </p>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-gray-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-gray-300 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                      Rruga Memo Meto, Pallati 59/7, Apartamenti 9
                    </p>
                    <p className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                      TIRANE 1000
                    </p>
                    <p className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                      Albania
                    </p>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-white/10 mb-8"></div>

              {/* Email */}
              <div className="mb-6">
                <p
                  className="text-xs font-semibold tracking-widest uppercase text-emerald-400 mb-3"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Email
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-gray-400 text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                    contact@addonshpk.com
                  </span>
                </div>
              </div>

              {/* Phone */}
              <div className="mb-10">
                <p
                  className="text-xs font-semibold tracking-widest uppercase text-emerald-400 mb-3"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Phone Number
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-gray-400 text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                    +1 5754689376
                  </span>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-white/10 pt-8">
                <p
                  className="text-gray-500 text-xs"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  &copy; {new Date().getFullYear()} ADDON SH.P.K. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
